import { render, staticRenderFns } from "./Certify.vue?vue&type=template&id=4baa5ad2&"
import script from "./Certify.vue?vue&type=script&lang=js&"
export * from "./Certify.vue?vue&type=script&lang=js&"
import style0 from "./Certify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports